module.exports = __webpack_public_path__ + "static/lato-latin-300italic.0a8e6f66.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-lato/files/lato-latin-300italic.woff2
// module id = ./node_modules/typeface-lato/files/lato-latin-300italic.woff2
// module chunks = 17241999800008180000